export const firebaseConfig = {
	"projectId": "outdr-prod",
	"databaseURL": "https://outdr-prod.firebaseio.com",
	"storageBucket": "outdr-prod.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyB8DguVMrEGo8p8hxJW5VgravD1nlAHMdE",
	"authDomain": "outdr-prod.firebaseapp.com",
	"messagingSenderId": "1048977973746"
};